var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 68,
  height: 68,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 34,
  fill: "#EBF5FA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "m48.502 46.038-8.296-8.293c3.47-4.57 3.048-11.171-1.1-15.318-4.572-4.57-12.022-4.57-16.678 0-4.57 4.57-4.57 12.017 0 16.672 2.201 2.2 5.165 3.47 8.297 3.47 2.54 0 4.994-.847 7.026-2.37l8.296 8.293c.339.339.762.508 1.185.508s.847-.17 1.185-.508c.762-.761.762-1.777.085-2.454m-17.693-6.94a8.33 8.33 0 0 1-5.925-2.453 8.324 8.324 0 0 1 0-11.848 8.48 8.48 0 0 1 5.925-2.454c2.117 0 4.318.846 5.926 2.454a8.324 8.324 0 0 1 0 11.848 8.33 8.33 0 0 1-5.926 2.454"
})));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "static/media/search.f0c2c830.svg";